<template>
    <v-dialog v-model="dialog" width="500" style="background-color:white">
    <v-card>
      <EncabezadoModal titulo="Detalle de la tarjeta" icono="mdi-text-box-search-outline" @cerrar="dialog = false" />
      <v-card-text class="pt-4">
      <v-row no-gutters>
                                            
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('code')}}:
                    {{ item.code }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('status')}}:
                    {{ item.status }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('amount')}}:
                    {{ $filters.currency(item.amount) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('has_expiration')}}:
                    {{ $filters.boolean(item.has_expiration) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('expiration_date')}}:
                    {{ $filters.date(item.expiration_date) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('activation_date')}}:
                    {{ $filters.datetime(item.activation_date) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('invoice')}}:
                    {{ $filters.name(item.invoice) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('user_created')}}:
                    {{ $filters.name(item.user_created) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('created_at')}}:
                    {{ $filters.datetime(item.created_at) }}
                </v-col>
                                            </v-row>
      </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn color="secondary" @click="dialog = false;" small class="btn--close" >
                <v-icon small>mdi-close</v-icon>{{$t('Cerrar')}} </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        data() {
            return {
                dialog: false,
                item: {}
            };
        },
        methods: {
            renderItem(item) {
                this.item = item;
                this.dialog = true;
            }
        }
    }
</script>
